export default __webpack_public_path__ + "static/media/oscer-pres-muscle-cramps.844e4b42.svg";